"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApplicableTerm = void 0;

var _Terms = require("self-service-api/constants/Terms");

// If the desired term is unavailable, return the available term instead
var getApplicableTerm = function getApplicableTerm(desiredTerm, availableTermsMap) {
  if (!availableTermsMap[desiredTerm]) {
    return desiredTerm === _Terms.MONTHLY ? _Terms.ANNUAL : _Terms.MONTHLY;
  }

  return desiredTerm;
};

exports.getApplicableTerm = getApplicableTerm;